import { render, staticRenderFns } from "./CourseTestTable.vue?vue&type=template&id=0584a630&scoped=true"
import script from "./CourseTestTable.vue?vue&type=script&lang=ts"
export * from "./CourseTestTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584a630",
  null
  
)

export default component.exports